import type { AgentRow } from "../api/agents";

const DOT_COLORS: Record<string, string> = {
  offline: "bg-slate-300",
  provisioning: "bg-amber-400",
  needs_attention: "bg-red-500",
  blocked: "bg-orange-400",
  uninstalled: "bg-slate-200",
};

export function StatusDot({ status }: { status: AgentRow["status"] }) {
  if (status === "online") {
    return (
      <span className="relative flex h-3 w-3">
        <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-emerald-400 opacity-75" />
        <span className="relative inline-flex h-3 w-3 rounded-full bg-emerald-500" />
      </span>
    );
  }
  return (
    <span
      className={`inline-flex h-3 w-3 rounded-full ${DOT_COLORS[status] ?? "bg-slate-200"}`}
    />
  );
}

const PILL_MAP: Record<AgentRow["status"], { label: string; className: string }> = {
  online: { label: "Online", className: "bg-emerald-100 text-emerald-900" },
  offline: { label: "Offline", className: "bg-slate-100 text-slate-600" },
  provisioning: { label: "Setting up", className: "bg-amber-100 text-amber-900" },
  needs_attention: { label: "Needs attention", className: "bg-red-100 text-red-800" },
  uninstalled: { label: "Removed", className: "bg-slate-100 text-slate-500" },
  blocked: { label: "Blocked", className: "bg-orange-100 text-orange-800" },
};

export function StatusPill({ status }: { status: AgentRow["status"] }) {
  const meta = PILL_MAP[status];
  return (
    <span className={`shrink-0 rounded-full px-3 py-1 text-xs font-medium ${meta.className}`}>
      {meta.label}
    </span>
  );
}
